<h3 class="title">{{ title }}</h3>
<div class="head-content">
  <ng-content></ng-content>
</div>
<button class="btn btn-accent toggle-btn" (click)="toggleTab.emit()">
  <fa-icon [icon]="['fas', 'angle-down']" [rotate]="isOpen ? 180 : undefined"></fa-icon>
</button>
